import { TRating } from '../../types/rating';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TGetRatingSucceed, ERatingActionTypes } from './types';

export const getRatingSucceed: (rating: TRating[]) => TGetRatingSucceed = actionGenerator<
  ERatingActionTypes.Succeed,
  TRating[]
>(ERatingActionTypes.Succeed);
